import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
//import { ParentChildService } from '../../../../../components/parentchild/parentchild.service';
import { ParentChildService } from '../parentchild-advanceQ.service';
import { NoticeboardService } from '../../../../../components/noticeboard/noticeboard/noticeboard.service';
import { DataAnalyticsService } from '../../../../../components/dataAnalytics/dataAnalytics.service';
import { ConfirmationService, Paginator } from 'primeng/primeng';
import { DropdownModule } from 'primeng/primeng';
import { LocalStorageService } from "ng2-webstorage";
import { MessageService } from 'primeng/components/common/messageservice';
import{addParentChildModel,motherChildModel} from '../../../../../components/parentchild/addparent/addparentchild.model';
import { element } from 'protractor';

@Component({
  selector: 'parentchildQ',
  templateUrl: 'parentchildQ.component.html',
  styleUrls: ['parentchildQ.component.scss']
})

export class SubParentChildQComponent implements OnInit {
  @ViewChild('paginator') paginator: Paginator
  // display: boolean = false;
  // editDisplay:boolean=false;
  display = "none";
  editDisplay = "none";
  public data: any;
  public childInfo: any;
  public ChildGenderId : number;
  public childview: any;
  public Mappeddata: any;
  public Sections: any;
  public maxSize: number = 10;
  public bigTotalItems: number;
  public bigCurrentPage: number = 1;
  public numPages: number = 0;
  public addeventmodel: any;
  public StandardId: any;
  public SectionId: any;
  public searchString:any;
  public input:any;
  public spinnershow: boolean = false;
  public selectedRows: number = 10;
  public addparentchildmodel=new addParentChildModel();
  public isUserSchoolAdmin: boolean = false;
  public YearData: any;
  public selectedYear1: any;
  public filteredData: any;

  public academicYear


  tempSection: any;

  constructor(private noticeboardService: NoticeboardService, private localStorage: LocalStorageService, private messageService: MessageService, private confirmationService: ConfirmationService, private parentchildservice: ParentChildService, private dataAnalyticsService: DataAnalyticsService, private router: Router) {
    this.Sections =null;
    // this.Sections=true;

  }
  ngOnInit() {
    this.isUserSchoolAdmin = this.localStorage.retrieve("IsSchoolAdminUser");
    //this.getParentsList(this.bigCurrentPage,this.selectedRows);
    
    // this.getSection(event);
    this.getYearData()
  }
  onSearchChange(searchString) {
    this.searchString = searchString;
    this.getChildsList(this.bigCurrentPage,this.selectedRows);
  }
  private updateCurrentPage(currentPage: number): void {
    setTimeout(() => this.paginator.changePage(currentPage));
  }


  

  private getChildsList(pagenum,rows) {
    this.spinnershow = true;
    this.parentchildservice.getChildNameList(pagenum, this.searchString).finally(() => { this.spinnershow = false }).subscribe(
      response => {
        this.bigTotalItems = (Number(response['TotalPages']) * this.maxSize);
        this.data = response['items'];
      },
      error => {
      });
  }

  searchDetails() {
    if(!this.StandardId)this.StandardId='';
    if(!this.SectionId) this.SectionId='';
    if(!this.searchString) this.searchString='';
    this.parentchildservice.GetParentsListBySearch(1,this.StandardId, this.SectionId,this.searchString).finally(() => { }).subscribe(
      response => {
         this.bigTotalItems = (Number(response['TotalPages']) * this.maxSize);
        this.data = response['items'];
        console.log(this.data);
        this.updateCurrentPage(0);
      },
      error => {
      });
  }

  sortingfunc(a, b) { //Added by Sashitha to sort grades by numbers first then alphabetically. Issue was 1,10,2,3,4,a,b like that. Fixed to 1,2,3,4,10,a,b
    if(!isNaN(a.standardsName) && !isNaN(parseFloat(a.standardsName)) && !isNaN(b.standardsName) && !isNaN(parseFloat(b.standardsName))){
      if (Number(a.standardsName) < Number(b.standardsName)){
        return -1;
      }
      if (Number(a.standardsName) > Number(b.standardsName)){
        return 1;
      }
    }else{
      if (a.standardsName < b.standardsName){
        return -1;
      }
      if (a.standardsName > b.standardsName){
        return 1;
      }
    }
    return 0;
  }

  public postParentChildUpdate(childInfo) {
    //this.addDepartmentmodel['schoolId'] = this.schoolId;
    this.parentchildservice.updateParentChildList(childInfo).finally(() => { }).subscribe(
      response => {
        // this.editDisplay= false;
        // this.display = false;
        this.editDisplay = "none";
        this.display = "none";
        this.getParentsList(this.bigCurrentPage, this.selectedRows);
        this.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: 'Updated Successfully' });
      },
      error => {console.log(error) });
  };

  private getYearData() {
    this.dataAnalyticsService.getYear()._finally(() => { }).subscribe(
      response => {
        this.YearData = response['yearList'];
        try {
            //this.selectedYear1 = this.YearData[1];
            this.getClassSection();

        } catch (error) {

        }

        this.getClassSection();
      }
    )
  }
  changeYear() {
    this.academicYear = this.selectedYear1.YearId
    console.log("AcademicYear",this.academicYear)
    this.filterDataByAcademicYear();
    this.getParentsListStudentView(this.bigCurrentPage,this.selectedRows, this.academicYear);



  };

  filterDataByAcademicYear() {
    if (this.selectedYear1) {
        this.filteredData = this.data.filter(item => item.AdmissionYear === this.selectedYear1);
    } else {
        // If no academic year is selected, show all data
        this.filteredData = this.data;
    }
}
  

  private getClassSection() {
    this.noticeboardService.getClassSectionMap().finally(() => { }).subscribe(
      response => {
        this.Mappeddata = response;
        console.log('Mappeddata',this.Mappeddata);
        this.Mappeddata.sort(this.sortingfunc);
       },
      error => {
      });
  };

  changeClass(event: any) {
    this.getSection(event);
    console.log(event,'e')
  };
  getSection(event: any) {
    var tempSection = [];
    tempSection = this.Mappeddata.filter(ele => ele['standardsName'] == event);
    for (let key in tempSection) {
      this.Sections = tempSection[key];
    }
    console.log(tempSection,'tempSection')
  };
  changeSection(event: any) {
    var tempSection = [];
    tempSection = this.Sections.Sections.filter(ele => ele['sectionName'] == event);
    this.addeventmodel['sectionName'] = tempSection[0]['sectionName'];
    this.getSection(event);
  };

  private getParentsList(pagenum, rows) {
    this.parentchildservice.GetParentsList(pagenum, rows).finally(() => { }).subscribe(
      response => {
        this.bigTotalItems = (Number(response['TotalPages']) * this.maxSize);
        console.log('pagination',this.bigTotalItems)
        this.data = response['items'];
      },
      error => {

      });
  };

  //Jaliya
  private getParentsListStudentView(bigCurrentPage,selectedRows,academicYear) {
    this.parentchildservice.GetParentsListStudentView(bigCurrentPage,selectedRows,academicYear).finally(() => { }).subscribe(
      response => {
        this.bigTotalItems = (Number(response['TotalPages']) * this.maxSize);
        console.log('pagination',this.bigTotalItems)
        this.data = response['items'];
      },
      error => {

      });
  };
  
  confirm() {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to perform this action?',
      accept: () => {
        //Actual logic to perform a confirmation
      }
    });
  }
  viewChild(parentChild){
    this.childview =parentChild;
    // this.display = true;
    this.display = "block";
  }
  viewChildAdvanced(parentChild){
    //this.router.navigate(['parentchild/View/child/' + parentChild.ChildId]);
    //this.router.navigate(['parent/1221/student-profile/']);
    this.router.navigate(['parent/1221/View/child/' + parentChild.ChildId]);

  }

  onCloseHandled() {
    this.display = "none";
  }

  editChild(parentChild) {
    // this.editDisplay = true;
    this.editDisplay = "block";
    this.childInfo = parentChild;
    this.changeClass(this.childInfo.Standard);
    console.log(parentChild,'parentChild')

  }

  onCloseHandled1() {
    this.editDisplay = "none";
  }


  pageChanged(event) {
    console.log(event);
    this.bigCurrentPage = event.page+1;
    this.selectedRows = event.rows;
    console.log("page",this.bigCurrentPage);
    console.log("rows",this.selectedRows);
    // this.getParentsList(event.page);

    if(!this.StandardId)this.StandardId='';
    if(!this.SectionId) this.SectionId='';
    if(!this.searchString) this.searchString='';
    this.parentchildservice.GetParentsListBySearch(this.bigCurrentPage,this.StandardId, this.SectionId,this.searchString).finally(() => { }).subscribe(
      response => {
         this.bigTotalItems = (Number(response['TotalPages']) * this.maxSize);
        this.data = response['items'];
        console.log(this.data);
      },
      error => {
      });
  }
  gotoAddParent() {
    this.router.navigate(['parentchild/addparentchild'])
  }

  
}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/parentchild/viewschool/parentchildQ.component.ts